import { Anchoring } from './Anchoring';
export default class AnchoringLetGoData extends Anchoring {
    constructor(anchor, freeText) {
        super(anchor, freeText);
    }
}
//# sourceMappingURL=AnchoringLetGoData.js.map